export const algoliaSearchApiKey = "ef81e0ba7e858ff533016aa3d6db5d90"
export const algoliaAppID = "VNF5GFP4JI"
